const { $$ } = window

export default class ProductFilter {
  constructor() {
    this.filters = $$(".product-filters input")
    this.filters._.addEventListener("click", this.updateDisplay)
    this.teasers = $$("[data-product-teasers] > .column")
    this.noProducts = $$("[data-product-teasers-none]")

    this.teasers.forEach((teaser) => {
      teaser.querySelector("a").addEventListener("click", this.followLink)
    })

    // initial check
    this.updateDisplay()
  }

  checkedFilters = () => this.filters.filter((filter) => filter.checked)

  updateDisplay = () => {
    const checkedFilters = this.checkedFilters()
    let visibleTeasersCount = 0
    let variants

    this.teasers.forEach((teaser) => {
      // create array of all product variants stored in the data-variant-i attributes
      variants = []
      for (let i = 0; i < teaser.dataset.variantCount; i++) {
        variants.push(teaser.dataset[`variant-${i}`].split(" "))
      }

      if (
        checkedFilters.length === 0 ||
        // at least one (some) of the variants must include every checked filter
        variants.some((variant) =>
          checkedFilters.every((filter) => variant.includes(filter.name)),
        )
      ) {
        teaser.style.display = "block"
        visibleTeasersCount++
      } else teaser.style.display = "none"
    })

    const displayNoProd = visibleTeasersCount === 0 ? "block" : "none"
    this.noProducts.forEach((noProd) => (noProd.style.display = displayNoProd))
  }

  followLink = (e) => {
    const checkedFilters = this.checkedFilters()

    if (checkedFilters.length > 0) {
      e.preventDefault()
      window.location.href =
        e.currentTarget.href +
        "?filters=" +
        this.checkedFilters()
          .map((filter) => filter.name)
          .join(".")
    }
  }
}
